'use client';
import { Props as BeautyStoreNewsletterSubscribeProps } from './beauty-store-newsletter-subscribe.component';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicBeautyStoreNewsletterSubscribeComponent: ComponentType<BeautyStoreNewsletterSubscribeProps> =
  dynamic(() => import('./beauty-store-newsletter-subscribe.component'));

export default DynamicBeautyStoreNewsletterSubscribeComponent;

export function calculateBeautyStoreNewsletterSubscribePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
